import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopUpHtmlModel } from './pop-up-html.model';

@Component({
  selector: 'app-pop-up-html-onboarding',
  templateUrl: './pop-up-html.component.html',
  styleUrls: ['./pop-up-html.component.scss'],
})
export class PopUpHtmlComponent {
  title = '';

  message = '';

  messageParams = {};

  list: string[] | undefined;

  okColour = 'accent';

  okText = 'common.ok';

  cancelText: string | undefined;

  showCloseButton: boolean;

  roundButton?: boolean;

  constructor(
    public dialogRef: MatDialogRef<PopUpHtmlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopUpHtmlModel,
    private ngZone: NgZone,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.messageParams = data.messageParams || {};
    this.cancelText = data.cancelText;
    this.list = data.list;
    this.showCloseButton = !!data.showCloseButton;
    this.roundButton = !!data.roundButton;

    if (data.okText) {
      this.okText = data.okText;
    }

    if (data.okColour) {
      this.okColour = data.okColour;
    }
  }

  onClose(): void {
    this.ngZone.run(() => {
      this.dialogRef.close(false);
    });
  }

  onYesClick(): void {
    this.ngZone.run(() => {
      this.dialogRef.close(true);
    });
  }
}
